import { h } from 'preact';
import Image from '../utils/image';

const GwpPromoBanner = ({
  id,
  className = '',
  bannerTitle,
  productTitle,
  promoMessage,
  productMessage,
  image,
  mode = 'banner', // 'banner' or 'offer-gift',
  handleAddItem = () => undefined,
}) => (
  <div className={`bg-grey-12${className && ` ${className}`}`}>
    <div className="p-2 flex items-center gap-3 bg-white rounded">
      {image ? (
        <div className="basis-16 w-16 h-16 shrink-0">
          <Image src={image} classes="w-full object-contain" />
        </div>
      ) : null}
      <div className="flex flex-col justify-center gap-1.5">
        {bannerTitle ? (
          <p className="text-[10px] text-brown-1 font-medium uppercase leading-none tracking-[0.6px]">{bannerTitle}</p>
        ) : null}
        {productTitle ? (
          <p className="text-[16px] text-brown-1 font-normal uppercase leading-none">{productTitle}</p>
        ) : null}
        {promoMessage || productMessage ? (
          <p className="text-[12px] text-brown-1/80 font-normal leading-none">
            {mode === 'offer-gift' ? productMessage : promoMessage}
          </p>
        ) : null}
      </div>
      {mode === 'offer-gift' ? (
        <button
          className="h-[30px] px-6 rounded-full border border-brown-1 flex items-center hover:opacity-80 transition-opacity duration-300"
          onClick={() => handleAddItem(id)}
        >
          <span className="text-[11px] font-medium leading-none uppercase">Add</span>
        </button>
      ) : null}
    </div>
  </div>
);

export default GwpPromoBanner;
